module.exports = __webpack_public_path__ + "img/구름많음.30af159f.png";